import { useQueryClient } from '@tanstack/react-query';
import { useApi, ApiError } from '@/hooks/useApi';
import { useModeAwareMutation } from '@/hooks/useModeAwareQuery';

export interface AddPromiseNoteRequest {
  promiseId: string;
  notes: string;
}

export function useAddPromiseNote() {
  const { apiBaseUrl, getHeaders } = useApi();
  const queryClient = useQueryClient();

  return useModeAwareMutation<void, Error, AddPromiseNoteRequest>(
    async (request) => {
      const { promiseId, ...body } = request;
      const headers = await getHeaders();
      const response = await fetch(`${apiBaseUrl}/api/v1/promises/${promiseId}/add-note`, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new ApiError(
          errorData.message || `HTTP error ${response.status}`,
          response.status,
          errorData
        );
      }
      // 201 Created with null body — no need to parse JSON
    },
    () => {
      // Demo mode: no-op, just return void
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["promise-recent-activities"] });
        queryClient.invalidateQueries({ queryKey: ["promise-audit-logs"] });
        queryClient.invalidateQueries({ queryKey: ["promises-to-pay"] });
        queryClient.invalidateQueries({ queryKey: ["promise-to-pay"] });
      },
    }
  );
}
